<template>
  <span>
    <b-link href="#" v-if="item.model_name != 'traceability'" @click.prevent="$bvModal.show(modalId)"
      ><i class="fa fa-lg fa-search"></i
    ></b-link>
    <b-modal
      :id="modalId"
      @hide="clearHistoryDetail()"
      @show="getHistoryDetail(item.id, item.history_id, item.model_name)"
      :title="`Detalle de ${item.model_name}`"
      cancel-title="Cancelar"
    >
      <b-spinner v-if="loading"></b-spinner>
      <div v-if="!loading && item_detail">
        <ul v-for="value in Object.entries(item_detail)">
          <li v-if="value[0] != 'changes'">
            {{ translate(value[0]) }}: <strong>{{ value[1] | check_boolean }}</strong>
          </li>
          <li v-if="value[0] == 'changes'">
            {{ translate(value[0]) }}:
            <ul v-for="val in value[1]">
              <li>
                {{ translate(val.field) }}: <strong>{{ val.old }}</strong> cambiado por
                <strong>{{ val.new }}</strong>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <p v-if="!item_detail">Nada que mostrar</p>
    </b-modal>
  </span>
</template>

<script>
import { translate } from "./traducciones";
export default {
  name: "HistoryDetailModal",
  data() {
    return {
      loading: false,
      item_detail: null
    };
  },
  filters: {
    check_boolean(value) {
      if (value === true) {
        return "Sí";
      }
      if (value === false) {
        return "No";
      } else {
        return value;
      }
    }
  },
  props: {
    topic: {
      type: String,
      default: ""
    },
    item: {
      type: Object,
      dafault: () => {}
    }
  },
  computed: {
    modalId() {
      return `history-details-modal-${this.topic}-${this.item.history_id}`;
    }
  },
  methods: {
    translate: translate,
    async getHistoryDetail(model_id, history_id, model_name) {
      const thisV = this;
      let url = "";
      thisV.loading = true;
      url = `/history/${model_name}/${model_id}/detail/${history_id}`;
      try {
        const response = await thisV.$axios({
          method: "GET",
          url: url
        });
        thisV.item_detail = response.data;
        thisV.loading = false;
      } catch (error) {
        if (error.response.status_code != 500) {
          thisV.message = error.response.data.detail;
        } else {
          thisV.$toast.error("Problemas al cargar proceso. Error interno.", "");
        }
        thisV.loading = false;
      }
    },
    clearHistoryDetail() {
      this.item_detail = null;
    }
  }
};
</script>

<style>
>>> b-link {
  a.disabled {
    pointer-events: none;
  }
}
</style>
